module.exports = __webpack_public_path__ + "static/media/observer-perspective-large.3b4d3d7f.png";